import {
    Settings as GenericIcon,
    Person as ProfileIcon,
    //Person as UsersIcon,
    //PeopleAlt as EmployeesIcon,
    //BarChart as BarChartIcon,
    Notifications as NotificationsIcon,
    CalendarMonth as PlanificationsIcon,
    Settings as PlanificationsConfigIcon,
    EventBusy as UnproductiveIcon,
    EventBusy as HolidaysIcon,
    Groups as TeamIcon,
    Groups as WorkersIcon,
    Factory as ProvidersIcon,
    Construction as PlansIcon,
    Home as ZonesIcon,
    IncompleteCircle as LPSIcon,
    Info as PlanificationsInfoIcon,
    TaskAlt as ActivitiesIcon,
    Flag as RestrictionsIcon,
    Analytics as ReportsIcon,
    ConfirmationNumber as TicketsIcon,
    Settings as ResourcesIcon,
    Agriculture as ResourcesRentalsIcon,
    FormatListBulleted as ResourcesGroupsIcon
} from '@mui/icons-material';

import { checkViewPath, replaceIfItemView } from '@/utils/Table';

// the options on the menu
/*
select * from app_menu where id = 2;

select * from app_rol_menu where app_menu_id = 2;

select * from app_rol where id = 33;
*/

/*
https://www.npmjs.com/package/path-to-regexp
Constant path: orders
Dynamic segment: orders/:segment
Optional segment: orders{/:segment}?
One or more segments: orders{/:segment}+
Zero or more segments: orders{/:segment}*
*/

const getMenuOptions = (t) => {

    // menu
    const menu = [
        {
            kind: 'header',
            title: t('menu.header')
        },
        {
            segment: 'profile',
            pattern: '(profile|forgot)',
            title: t('menu.profile'),
            icon: <ProfileIcon />,
        },
        {
            segment: 'tickets',            
            pattern: '(tickets/manage|tickets/stats|tickets/view/[0-9]+)',
            title: t('tickets.menu.title'),
            icon: <TicketsIcon/>
        },
        /*{(tickets{/:section}|
            segment: 'notifications',
            pattern: 'notifications{/:section}',          
            title: t('menu.notifications'),
            icon: <NotificationsIcon />,
        },*/
        /*{
            kind: 'divider',
        },
        {
            kind: 'header',
            title: t('tickets.menu.header')
        },*/                
        {
            kind: 'divider',
            roles: [
                'planification_admin','planification','company_management',
                'purchasing_responsible','purchasing','technical_office',
                'projects_manager','manager'
            ]
        },
        {
            kind: 'header',
            title: t('planifications.menu.header'),
            roles: [
                'planification_admin','planification','company_management',
                'purchasing_responsible','purchasing','technical_office',
                'projects_manager','manager'
            ]
        },        
        {
            segment: 'planifications',
            pattern: 'planifications{/view/:id}',
            title: t('planifications.menu.title'),
            icon: <PlanificationsIcon/>,
            roles: [
                'planification_admin','planification','company_management',
                'purchasing_responsible','purchasing','technical_office',
                'projects_manager','manager'
            ]
            //companies: [1]
        },
        {
            segment: 'planifications/planification_reports',
            pattern: 'planifications/planification_reports{/:section}',
            title: t('planification_reports.menu.title'),
            icon: <ReportsIcon/>,
            roles: [
                'planification_admin','planification','company_management',
                'purchasing_responsible','purchasing','technical_office',
                'projects_manager','manager'
            ]
        },
        {
            segment: 'planifications/config',
            title: t('planifications.menu.config'),
            icon: <PlanificationsConfigIcon />,
            roles: ['planification_admin','company_management'],
            children: [
                {
                    segment: 'planification_activities',                    
                    pattern: 'planification_activities{/view/:id}',
                    //pattern: 'planification_activities/view{/:id}',
                    title: t('planification_activities.menu.title'),
                    icon: <ActivitiesIcon/>
                },
                {
                    segment: 'planification_restrictions',
                    pattern: 'planification_restrictions{/view/:id}',
                    title: t('planification_restrictions.menu.title'),
                    icon: <RestrictionsIcon/>
                },
                {
                    segment: 'planification_lps',
                    pattern: 'planification_lps{/view/:id}',
                    title: t('planification_lps.menu.title'),
                    icon: <LPSIcon/>
                },
                {
                    segment: 'planification_holidays', 
                    pattern: 'planification_holidays{/view/:id}',                   
                    title: t('planification_holidays.menu.title'),
                    icon: <HolidaysIcon/>
                }, 
                {
                    // /planification/config/planification_unproductives
                    segment: 'planification_unproductives', 
                    pattern: 'planification_unproductives{/view/:id}',                   
                    title: t('planification_unproductives.menu.title'),
                    icon: <UnproductiveIcon/>                    
                },                
                {
                    segment: 'planification_zones',
                    pattern: 'planification_zones{/view/:id}',
                    title: t('planification_zones.menu.title'),
                    icon: <ZonesIcon/>
                },
                {
                    segment: 'planification_persons',
                    pattern: 'planification_persons{/view/:id}',
                    title: t('planification_persons.menu.title'),
                    icon: <TeamIcon/>
                },
                {
                    segment: 'plan_team',
                    pattern: 'plan_team{/view/:id}',
                    title: t('plan_team.menu.title'),
                    icon: <WorkersIcon/>
                },
                {
                    segment: 'planification_providers',
                    pattern: 'planification_providers{/view/:id}',
                    title: t('planification_providers.menu.title'),
                    icon: <ProvidersIcon/>
                },
            ]
        },
        {
            segment: 'planifications/info',
            title: t('planifications.menu.info'),
            icon: <PlanificationsInfoIcon />,
            roles: ['planification_admin','company_management'],    
            children: [      
                {
                    segment: 'planifications_historical',
                    pattern: 'planifications_historical{/view/:id}',      
                    title: t('planifications_historical.menu.title'),
                    icon: <PlanificationsIcon/>
                },         
                {
                    segment: 'plans',
                    pattern: 'plans{/view/:id}',
                    title: t('plans.menu.title'),
                    icon: <PlansIcon/>
                },
                {
                    segment: 'cncs',
                    pattern: 'cncs{/view/:id}',
                    title: t('cncs.menu.title'),
                    icon: <GenericIcon/>
                }
            ]
        },
        {
            kind: 'divider',
            roles: ['campa','projects_manager','manager']
        },
        {
            kind: 'header',
            title: t('resources.menu.header'),
            roles: ['campa','projects_manager','manager']
        },
        {
            segment: 'resources/resource_groups',
            pattern: 'resources/resource_groups{/view/:id}',
            title: t('resource_groups.menu.title'),
            icon: <ResourcesGroupsIcon/>,
            roles: ['resources_groups']
        },
        {
            segment: 'resources',
            pattern: 'resources{/view/:id}',
            title: t('resources.menu.title'),
            icon: <ResourcesIcon/>,
            roles: ['campa']
        },
        {
            segment: 'resources/resource_rentals',            
            pattern: 'resources/resource_rentals{/:id}*',
            title: t('resource_rentals.menu.title'),
            icon: <ResourcesRentalsIcon/>,
            roles: ['campa','projects_manager','manager']
        }
    ];

    return menu;
}

export const getMenu = (t,user) => {

    var menu = [];

    // this is used later to check if it is menu/submenu
    var menuConfig = [];

    // build rest of menu depending on the user roles

    // get the user roles
    var userRoles = user?.roles_ids;
    if(!userRoles || userRoles?.length === 0){
        userRoles = [];
    }

    // get the user roles tags
    var userRolesTags = user?.roles_tags;
    if(!userRolesTags || userRolesTags?.length === 0){
        userRolesTags = [];
    }
    
    const menuOptions = getMenuOptions(t);

    // get only the options that the user can access
    menuOptions?.map((menuOption) => {

        var menuRoles = menuOption?.roles;

        var granted = false;

        // if no roles, all can access
        if(!menuOption || !Object.hasOwn(menuOption,'roles')){            
            granted = true;
        }
        else{
            // if user is root (1), allow
            if(userRolesTags.includes('root')){
                granted = true;
            }
            else{
                // check if the user has the role tag for that menu
                if(menuRoles.length > 0){                    
                    granted = userRolesTags.some(item => menuRoles.includes(item));
                }
            }
        }

        var grantedCompany = false;
        if(granted){

            // check if only for some companies
            if(menuOption?.companies){
                if(menuOption?.companies?.includes(user?.company)){
                    grantedCompany = true;
                }
            }
            else{
                // if no companies specified, all can access
                grantedCompany = true;
            }
        }

        if(grantedCompany){                

            // generate subpaths for children
            menuOption.path = menuOption?.segment;
            var options = [menuOption];               

            while(options && options?.length > 0){

                var option = options.pop();                    

                if(option && Object.hasOwn(option,'segment')){

                    menuConfig[option?.path] = option;
                    
                    if(option?.children && option.children.length > 0){

                        // save on variable to remove children that are not allowed by roles
                        var allowedChildren = [];

                        option.children?.map((child) => {

                            const childRoles = child?.roles;

                            // check if child has roles. if no roles, it is allowed
                            // if no roles, all can access
                            if(
                                !childRoles || 
                                userRolesTags.includes('root') ||
                                (childRoles.length > 0 && userRolesTags.some(item => childRoles.includes(item)))
                            ){                                
                                child.path = option.path+'/'+child?.segment;                                
                                options.push(child);

                                allowedChildren.push(child);
                            }
                        });

                        // both are valid
                        //menuOptions[index].children = allowedChildren;
                        option.children = allowedChildren;
                    }
                }
            }

            // add menu option
            menu.push(menuOption);
        }
    });

    return [menu,menuConfig];
}

// check if the user has permission on the menu
const hasMenuPermission = (user,menu,menuConfig) => {

    var hasPermission = false;

    // if home
    if(menu.length === 0){
        hasPermission = true;
    }
    else{
        // if notifications (not in the menu)
        if(menu === 'notifications'){
            hasPermission = true;
        }
        else{
            // versions only root user can see
            if(menu === 'versions' && user?.roles_tags?.includes('root')){
                hasPermission = true;
            }
            else{
                // if menu allowed for the user
                if(menuConfig[menu]){
                    hasPermission = true;
                }
            }
        }
    }

    return hasPermission;
}

// to get the menu from the path
export const getMenuFromPath = (user, menuConfig, path = null) => {

    if(!path){
        path = window.location.pathname;
    }

    // remove if menu/view/N
    var pathReplaced = replaceIfItemView(path);
    var split = pathReplaced.split('/');
    
    // get menu option

    // in case there are sections

    // number of maximum sections
    const withSections = [
        'planification_reports',
        'tickets',
        'notifications',
        'resource_rentals'
    ];

    withSections?.forEach((item) => {
    
        // matches with 0 or more sections
        var regExp = new RegExp(`/${item}((/[a-zA-Z0-9_-]+)*)$`);

        if(regExp.test(pathReplaced)){
            
            var matches = pathReplaced.match(regExp);

            // result is ['section1','section2',etc.]
            var result = matches[1].split('/').filter(segment => segment.length > 0);

            // to recover the full menu path without sections
            if(result && result?.length > 0){
                var posRemove = result?.length*-1;
                split = split.slice(0,posRemove);             
            }
        }
    });

    const menu = split.filter(item => item !== '').join('/');

    // check if user has permission on the menu
    const hasPermission = hasMenuPermission(user,menu,menuConfig);

    if(hasPermission){
        return menu;
    }
    else{
        return null;
    }
}

// set the breadcrumbs for the pages
// using this to show/hide conditionally
export const getMenuBreadcrumbs = (t,router) => {
    
    // return null to get default title (taken from the menu config)
    var breadcrumbs = null;

    var path = router.pathname;

    // if item/view/N do not show breadcrumb
    if(checkViewPath(path)){
        breadcrumbs = [];
    }
    else{
        // if submenu, show breadcrumbs, if not, do not show
        var split = path.split('/');
        if(split?.length > 2){

            // if not menus with tabs
            const parent = split[1];
            switch(parent){

                case 'notifications':
                case 'tickets':
                case 'resource_rentals':
                    // no breadcrumb
                    breadcrumbs = [];
                    break;

                    default:
                        // default option, show breadcrumb
                        breadcrumbs = null;
                        break;
            }
        }
        else{
            // no breadcrumb
            breadcrumbs = [];
        }
    }

    return breadcrumbs;
}

// set the title for the pages
// using this because for example for notifications there is no explicit menu
// so by default you don't see the title
export const getMenuTitle = (t,router) => {
    
    // return null to get default title (taken from the menu config)
    var title = null;

    const path = router.pathname;

    const split = path.split('/');

    if(split?.length > 1){

        var parent = split[1];

        switch(parent){

            case 'notifications':
                title = t('menu.notifications');
                break;

            case 'versions':
                title = t('menu.versions');
                break;

            case 'tickets':
                title = t('tickets.menu.title');
                break;
        }  
    }      

    return title;
}